module.exports = __webpack_public_path__ + "static/img/wood32.91a937e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood32.jpg
// module id = IVnN
// module chunks = 0